<div class="root" *transloco="let t; read: 'certificate'">
    <certificate-card></certificate-card>
    <ng-container *ngIf="certificate$ | async as certificate">
        <div class="root__actions">
            <div *ngIf="certificate.hasSwedishPersonalNumber" class="root__actions__item">
                <div class="root__actions__item__heading">{{ t("ssgHeading") }}</div>
                <ng-container *ngIf="!certificate.ssgConsentDate">
                    <div class="root__actions__item__intro" [innerHTML]="t('ssgNoConsentIntro')"></div>
                    <a [routerLink]="ssgConsentRoute" class="root__actions__item__anchor root__actions__item__anchor--ssg-registration"
                    [innerHTML]="t('ssgRegisterConsent')"></a>
                </ng-container>
                <ng-container *ngIf="certificate.ssgConsentDate">
                    <div class="root__actions__item__intro" [innerHTML]="t('ssgConsentIntro')"></div>
                    <div (click)="ssgAgreementModal.openModal()" class="root__actions__item__anchor root__actions__item__anchor--ssg-consent"
                        [innerHTML]="t('ssgViewConsent', { consentDate: certificate.ssgConsentDate | haDate: 'date' })"></div>
                </ng-container>
            </div>
            <div class="root__actions__item">
                <div class="root__actions__item__heading">{{ t("id06Heading") }}</div>
                <ng-container *ngIf="!certificate.id06ConsentDate">
                    <div class="root__actions__item__intro" [innerHTML]="t('id06NoConsentIntro')"></div>
                    <a [routerLink]="id06ConsentRoute" class="root__actions__item__anchor root__actions__item__anchor--id06-registration"
                       [innerHTML]="t('id06RegisterConsent')"></a>
                </ng-container>
                <ng-container *ngIf="certificate.id06ConsentDate">
                    <div class="root__actions__item__intro" [innerHTML]="t('id06ConsentIntro')"></div>
                    <div (click)="agreementModal.openModal()" class="root__actions__item__anchor root__actions__item__anchor--id06-consent"
                         [innerHTML]="t('id06ViewConsent', { consentDate: certificate.id06ConsentDate | haDate: 'date' })"></div>
                </ng-container>
            </div>
            <div class="root__actions__item">
                <div class="root__actions__item__heading">{{ t("educationEventsHeading") }}</div>
                <div class="root__actions__item__intro" [innerHTML]="t('educationEventsIntro')"></div>
                <a [routerLink]="'/publiceducationevents'" class="root__actions__item__anchor root__actions__item__anchor--search-education">{{
                    t("educationEventsCta") }}</a>
            </div>
            <div *ngIf="certificate.canOrderFreeCard" class="root__actions__item">
                <div class="root__actions__item__heading">{{ t("orderCardHeading") }}</div>
                <div class="root__actions__item__intro" [innerHTML]="t('orderCardIntro')"></div>
                <a [routerLink]="cardOrderRoute" class="root__actions__item__anchor root__actions__item__anchor--order-card">{{
                    t("orderCard") }}</a>
            </div>
            <div *ngIf="!certificate.canOrderFreeCard" class="root__actions__item">
                <div class="root__actions__item__heading">{{ t("replacementCardHeading") }}</div>
                <div class="root__actions__item__intro" [innerHTML]="t('replacementCardIntro')"></div>
                <a [routerLink]="replacementCardRequestRoute" class="root__actions__item__anchor root__actions__item__anchor--order-card">{{
                    t("orderReplacementCard") }}</a>
            </div>
        </div>

        <modal #agreementModal [closeLabel]="t('close')" width="wide" textSource="from-editor">
            <ng-container *ngIf="consentData$ | async as consentData">
                <div [innerHTML]="consentData.agreementText"></div>
                <div class="agreement-meta-data">
                    <div class="agreement-meta-data__item">
                        <div class="agreement-meta-data__item__label">{{ t('consentVersion') }}:</div>
                        <div class="agreement-meta-data__item__value">{{ consentData.agreementVersion }}</div>
                    </div>
                </div>
            </ng-container>
        </modal>

        <modal #ssgAgreementModal [closeLabel]="t('close')" width="wide" textSource="from-editor">
            <ng-container *ngIf="ssgConsentData$ | async as consentData">
                <div [innerHTML]="consentData.agreementText"></div>
                <div class="agreement-meta-data">
                    <div class="agreement-meta-data__item">
                        <div class="agreement-meta-data__item__label">{{ t('consentVersion') }}:</div>
                        <div class="agreement-meta-data__item__value">{{ consentData.agreementVersion }}</div>
                    </div>
                </div>
            </ng-container>
        </modal>
    </ng-container>
</div>
